export const mutations = {
    setFabricante(state, data) {
        state.banco = data
    },
    setFabricantes(state, data) {
        state.fabricantes = data
    },
    addFabricante(state, data){
        state.fabricantes.push(data)
    },
    removeFabricante(state, data){
        let index = state.fabricantes.map(x => x.id).indexOf(data.id);
        state.fabricantes.splice(index, 1)
    },
    setModalCadastrarFabricante(state, status) {
        state.modalCadastrarFabricante = status
    },
    setModalExcluirFabricante(state, status) {
        state.modalExcluirFabricante = status
    },
}

export default {}